<template>
  <div class="layout-main">
    
    <div class="wrap">
      <div class="title">
        <div class="main">
          <a> 进行中 </a>
        </div>
      </div>
      <div class="item-box">
        <div class="item">
          <div class="section">
            <div
              alt="课程封面"
              class="img"
              style="
                height: 126px;
                background-image: url(https://xqimg.imedao.com/17c12bc9ff71b963fe9b2b2b.png%21800.jpg)
                  0px 50% / cover no-repeat;
              "
            ></div>
            <div class="con">
              <div class="info">
                <h3 class="title">亚马逊实训03班期未测试20240701</h3>
                <p><strong>开始时间: </strong>2024-06-21 18:00:00</p>
                <p><strong>结束时间: </strong>2024-06-21 18:00:00</p>
                <p><strong>提前进入: </strong>2分钟</p>
                <p><strong>备注: </strong></p>
              </div>
              <div class="bottom">
                <div class="price_con">
                  <span class="free">免费</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wrap">
      <div class="title">
        <div class="main">
          <a> 待开考 </a>
        </div>
      </div>
      <div class="item-box">
        <div class="item">
          <div class="section">
            <div
              alt="课程封面"
              class="img"
              style="
                height: 126px;
                background-image: url(https://xqimg.imedao.com/17c12bc9ff71b963fe9b2b2b.png%21800.jpg)
                  0px 50% / cover no-repeat;
              "
            ></div>
            <div class="con">
              <div class="info">
                <h3 class="title">亚马逊-实习指导书</h3>
                <p>入门 / 实习指导书</p>
                <span>500人报名</span>
              </div>
              <div class="bottom">
                <div class="price_con">
                  <span class="free">免费</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="section">
            <div
              alt="课程封面"
              class="img"
              style="
                height: 126px;
                background-image: url(https://xqimg.imedao.com/17c12bc9ff71b963fe9b2b2b.png%21800.jpg)
                  0px 50% / cover no-repeat;
              "
            ></div>
            <div class="con">
              <div class="info">
                <h3 class="title">亚马逊-实习指导书</h3>
                <p>入门 / 实习指导书</p>
                <span>200人报名</span>
              </div>
              <div class="bottom">
                <div class="price_con">
                  <span class="">￥200</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wrap">
      <div class="title">
        <div class="main">
          <a> 已考完 </a>
        </div>
      </div>
      <div class="item-box">
        <div class="item">
          <div class="section">
            <div
              alt="课程封面"
              class="img"
              style="
                height: 126px;
                background-image: url(https://xqimg.imedao.com/17c12bc9ff71b963fe9b2b2b.png%21800.jpg)
                  0px 50% / cover no-repeat;
              "
            ></div>
            <div class="con">
              <div class="info">
                <h3 class="title">亚马逊-实习指导书</h3>
                <p>入门 / 实习指导书</p>
                <span>500人报名</span>
              </div>
              <div class="bottom">
                <div class="price_con">
                  <span class="free">免费</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="section">
            <div
              alt="课程封面"
              class="img"
              style="
                height: 126px;
                background-image: url(https://xqimg.imedao.com/17c12bc9ff71b963fe9b2b2b.png%21800.jpg)
                  0px 50% / cover no-repeat;
              "
            ></div>
            <div class="con">
              <div class="info">
                <h3 class="title">亚马逊-实习指导书</h3>
                <p>入门 / 实习指导书</p>
                <span>200人报名</span>
              </div>
              <div class="bottom">
                <div class="price_con">
                  <span class="">￥200</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.layout-main {
  width: 1200px;
  margin: 0 auto;
}

.main-container {
  display: flex;

  padding-top: 12px;
  width: 1200px;
  height: 350px;
  margin: 0 auto;
  justify-content: space-between;

  margin-bottom: 30px;
}

.nav-menu-container {
  border-radius: 8px;
  width: 280px;
  background: #ffffff;

  padding: 10px 0;
}

.nav-menu-item {
  box-sizing: border-box;
  width: 280px;
  height: 38px;
  padding: 0 12px;
  line-height: 38px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  color: rgb(153, 153, 153);
}
.nav-menu-item:hover {
  background: #ecf5ff;
  color: #66b1ff;
}

.nav-menu-item a:hover {
  text-decoration: none;
  cursor: pointer;
  text-decoration: underline;
  color: #66b1ff;
}

.nav-menu-item-title {
  margin-right: 8px;
  font-size: 14px;
  font-weight: 500;
  color: rgb(51, 51, 51);
}
.nav-menu-item-longtitle {
  line-height: 17px;
  font-size: 12px;
  font-weight: 400;
}

.banner-container {
  /* flex-grow: 1; */
  border-radius: 8px;
  width: 700px;
}

.user-container {
  border-radius: 8px;

  width: 200px;
  background: #ffffff;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.user-history {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  padding: 10px;
  height: 140px;
}

.user-history a {
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 2px 0;
  max-width: 180px;
  color: rgb(153, 153, 153);
}

.user-btn {
  width: 168px;
  height: 32px;
  border-radius: 18px;
  line-height: 32px;
  font-size: 14px;
  text-align: center;
  color: rgb(255, 255, 255);
  background-color: #66b1ff;
  outline: none;
  cursor: pointer;
  -webkit-transition: 0.1s all;
  -o-transition: 0.1s all;
  transition: 0.1s all;
}

.wrap {
  /* min-height: 395px; */
  margin-top: 10px;
  margin-bottom: 32px;
}

.wrap .title {
  display: flex;
  width: 100%;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 40px;
}

.wrap .title .main {
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.wrap .title .main a {
  color: #333;
  font-size: 24px;
  font-weight: 500;
  margin-right: 40px;
}

.wrap .title .main span {
  height: 34px;
  color: #666;
  display: inline-block;
  font-size: 14px;
  cursor: pointer;
  margin-right: 32px;
}

.wrap .title .main span.active {
  color: #00cc7e;
  border-bottom: 2px solid #00cc7e;
}

.wrap .item-box {
  min-height: 200px;
  /* overflow: hidden; */
  padding-top: 24px;
  display: flex;
}

.wrap .item-box .item {
  cursor: pointer;
  float: left;
  margin: 0 20px 20px 0;
  border-radius: 8px;
  -webkit-transition: all ease-in 0.2s;
  -o-transition: all ease-in 0.2s;
  transition: all ease-in 0.2s;
  line-height: 0;

  box-shadow: 0 2px 15px 0 rgba(0,0,0,.1);
}

.wrap .item-box .item:nth-child(5n) {
    margin-right: 0;
}

.section {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 224px;
  height: 282px;
  border-radius: 8px;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 0;
  overflow: hidden;
  -webkit-transition: all ease-in 0.2s;
  -o-transition: all ease-in 0.2s;
  transition: all ease-in 0.2s;
}

.section .img {
  width: 100%;
  max-height: 136px;
  overflow: hidden;
}

.section .con {
  position: relative;
  padding: 10px 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 156px;
  border-radius: 0 0 8px 8px;
}

.section .con .info {
  margin: 0;
  padding: 0;
  outline: none;

  height: 124px;
}

.section .con .info .title {
  max-height: 36px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  font-weight: bold;
  font-family: PingFangSC-Medium, PingFangSC;
  line-height: 18px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.section .con .info p {
  height: 12px;
  line-height: 12px;
  font-size: 12px;
  margin-top: 6px;
  color: #666;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .section .con .info span {
  position: absolute;
    bottom: 12px;
    right: 14px;
    display: inline-block;
    font-size: 12px;
    min-width: 50px;
    height: 12px;
    line-height: 12px;
    color: #999;
} */

.section .con .bottom {
  height: 20px;
  font-family: PingFangSC-Regular, PingFangSC;
}

.section .con .bottom .price_con {
  position: relative;
  text-align: left;
  top: -8px;

  padding: 2px;
  background: #00CC7E;
}

.section .con .bottom .price_con span {
  display: inline-block;
  color: #FF7A3E;
  font-size: 20px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
}

.section .con .bottom .price_con span.free {
  /* color: #00CC7E; */
  color: #fff;
}
</style>
